/**
 * Strip the query string from every property that looks like a URL.
 *
 * Pure and testable on purpose. The previous version lived inline in
 * PostHogProvider and named four properties — $current_url, $referrer,
 * $initial_current_url, $pathname — which meant it was only ever as complete as
 * someone's memory of posthog-js's property list. posthog-js also sets
 * $session_entry_url, $initial_referrer, $initial_pathname and
 * $prev_pageview_pathname, and adds more between releases.
 *
 * What makes this worth generalising rather than extending: the lifecycle
 * mail's preferences and feedback links carry the member's email address AND an
 * HMAC that opens their preferences with no sign-in. That is a bearer
 * credential. A sibling product shipped this exact leak with a scrubber already
 * in place, because the property that leaked was not in its list.
 *
 * Paths survive; only the query goes. The path is what we measure.
 */
export function scrubUrlProperties(
  props: Record<string, unknown>,
): Record<string, unknown> {
  for (const [k, v] of Object.entries(props)) {
    if (typeof v !== "string" || !v.includes("?")) continue;
    const absolute = /^https?:\/\//i.test(v);
    // A bare string with a "?" in it is a search term, not a URL — leave it.
    if (!absolute && !v.startsWith("/")) continue;
    try {
      const u = new URL(v, "https://x.invalid");
      props[k] = absolute ? u.origin + u.pathname : u.pathname;
    } catch {
      props[k] = v.split("?")[0];
    }
  }
  return props;
}
